import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Notification } from "../common/Notification";
import { addDardWebMonitoringCreditCard } from "../../store/service";
import { useTranslation } from "react-i18next";
interface IProps {
    closeDialog: any;
}

const DarkWebFinancialAccountAddCreditDialog: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const { register, errors, reset, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isValid, isSubmitting } = formState;
    const [creditCardNumber, setCreditCardNumber] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-dark-web-add-financial-acc");
        cancelBtn.addEventListener("click", () => {
            reset();
            props.closeDialog("cancel");
        });
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                reset();
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const creditCardNumberChange = (event: any): any => {
        setCreditCardNumber(event.currentTarget.value);
    };

    const addAccount = () => {
        setIsLoading(true);
        addDardWebMonitoringCreditCard(creditCardNumber)
            .then((data: any) => {
                if (data.isSuccess === true) {
                    Notification({
                        type: "success",
                        title: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addSuccess.title"),
                        message: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addSuccess.message"),
                        duration: 0,
                    });
                    props.closeDialog("close");
                } else {
                    if (data["errors"] && data["errors"].length > 0) {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.title"),
                            message:
                                data["errors"][0] === "Duplicate Card Number"
                                    ? tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.duplicateError.message")
                                    : tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.message"),
                            duration: 0,
                        });
                    } else {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.title"),
                            message: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.message"),
                            duration: 0,
                        });
                    }
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.title"),
                    message: tLang("identityVault.monitoredInformation.financialAccountWidget.toasterMessage.addError.message"),
                    duration: 0,
                });
                setIsLoading(false);
            });
    };

    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <div className="dialog-header">
                    <div className="dialog-icon status-default">
                        <em className="las la-plus"></em>
                    </div>
                    <h1>{tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.title")}</h1>
                </div>

                <div className="dialog-body">
                    <form id="form-add-dark-web-monitor-credit-card-account" onSubmit={handleSubmit(addAccount)}>
                        <React.Fragment>
                            <div className="form-row row">
                                <div className={errors["creditCartNumber"] ? "form-row status-error" : "form-row"}>
                                    <div className="form-label">
                                        <label htmlFor="creditCartNumber">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.inputLabel")}{" "}
                                            <span className="required" title="Mandatory">
                                                {" "}
                                                *{" "}
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input">
                                        <input
                                            aria-required="true"
                                            ref={register({ required: true, pattern: /^$|^(\d{15,16})$/ })}
                                            type="text"
                                            name="creditCartNumber"
                                            className="inputbox"
                                            id="creditCartNumber"
                                            maxLength={16}
                                            onChange={(e) => creditCardNumberChange(e)}
                                        />
                                        {{ ...errors["creditCartNumber"] }.type === "required" && (
                                            <span aria-required="true" className="form-error">
                                                {tLang(
                                                    "identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.validationMessage.required"
                                                )}
                                            </span>
                                        )}
                                        {{ ...errors["creditCartNumber"] }.type === "pattern" && (
                                            <span aria-required="true" className="form-error">
                                                {tLang(
                                                    "identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.validationMessage.pattern"
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" id="btn-cancel-dark-web-add-financial-acc" className="btn-default btn-link btn-no-padding btn-no-border">
                                        <span className="btn-text">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.cardDetails.addCardPopup.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};
export default DarkWebFinancialAccountAddCreditDialog;
